import React, { forwardRef } from "react";
import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom";

const NavLinkWrapper = forwardRef<HTMLAnchorElement, NavLinkProps>((props, ref) => (
  <RouterNavLink innerRef={ref} {...props} />
));

export default NavLinkWrapper;
